
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader } from "@/components/ui/loader";
import { FcGoogle } from "react-icons/fc";

export default function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();

  const handleLogin = async () => {
    await login();
  };

  useEffect(() => {
    document.title = "Login | Shekel";
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader size="lg" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-shekel-50 to-white p-4">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-shekel-600 rounded-full flex items-center justify-center">
              <span className="text-white text-4xl font-bold">₪</span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-shekel-800 mb-2">Shekel</h1>
          <p className="text-gray-500 mb-8">
            Manage your family's money with ease
          </p>
        </div>

        <div className="space-y-4">
          <Button
            onClick={handleLogin}
            size="lg"
            className="w-full flex items-center justify-center gap-2"
          >
            <FcGoogle className="w-5 h-5" />
            Continue with Google
          </Button>

          <p className="text-xs text-center text-gray-500 mt-8">
            By continuing, you agree to Shekel's Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}
